// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar-module__avatar--Fk1XJ"};